"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateDebounced = void 0;
var useStateDebounced_1 = require("./useStateDebounced");
Object.defineProperty(exports, "useStateDebounced", { enumerable: true, get: function () { return __importDefault(useStateDebounced_1).default; } });
//# sourceMappingURL=index.js.map